import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'sportRoomSponsor',
  getURL: 'appId/sponsor',
  sessionParams: ['appId'],
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  emptyMessage: "You don't have Sponsors, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the sponsor.',
    },
  ],
};
